import React from 'react'

class Headlines extends React.Component {
  render(){
    const data = this.props.data.contentData
    return(
    <div className="headlines">
      {data.map(item =>{
        return (
          <a
            href={item.gist.permalink}
            className="headline-link"
            key={ item.id }
          >
            { item.gist.title }
          </a>
        )
      })}
    </div>
    )
  }
}

export default Headlines
